// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import clientareahome from './routes/clientareahome';
import configureproductdomain from './routes/configureproductdomain';
import clientareaproductdetails from './routes/clientareaproductdetails';
import configureproduct from './routes/configureproduct';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  clientareahome,
  configureproductdomain,
  clientareaproductdetails,
  configureproduct
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js